export default {
  name: 'gallery',
  title: 'Gallery',
  type: 'array',
  of: [
    {
      type: 'string',
    },
  ],
}
